const user = {
    surname: '',
    name: '',
    email: '',
    color: '#1A639A',
    active: '',
    id: '',
    status: '',
    data: {
        society: '',
        society_mail: '',
        society_phone: '',
        phone: ''
    }
};

export default user
